import { LinkedCredential } from '../models';
import { ReadClaims, ReadDraftClaims } from '../types';
import { Credential } from './credential';
import { DraftCredentialWithClaims } from './draft/with-claims';
import { Claims } from './types';
import { VerifiableCredentialWithClaims } from './verifiable/with-claims';

type EnvelopedCredential<T extends Claims> = DraftCredentialWithClaims<T> | VerifiableCredentialWithClaims<T>;

export class CredentialWithClaims<T extends Claims> extends Credential<EnvelopedCredential<T>> {
    constructor(protected credential: EnvelopedCredential<T>) {
        super(credential);
    }

    canMapToDraft(): this is Credential<DraftCredentialWithClaims<T>> {
        return this.credential instanceof DraftCredentialWithClaims;
    }

    canMapToVerifiableCredential(): this is Credential<VerifiableCredentialWithClaims<T>> {
        return this.credential instanceof VerifiableCredentialWithClaims;
    }

    toLinkedCredential(): LinkedCredential<T> {
        return super.toLinkedCredential();
    }

    async getClaims(): Promise<ReadDraftClaims<T> | ReadClaims<T>> {
        return await this.credential.getClaims();
    }

    toDraft(): DraftCredentialWithClaims<T> {
        if (this.canMapToDraft()) {
            return this.credential;
        }
        throw new Error("CredentialWIthClaims can't be mapped to DraftCredentialWithClaims");
    }

    toVerifiableCredential(): VerifiableCredentialWithClaims<T> {
        if (this.canMapToVerifiableCredential()) {
            return this.credential;
        }
        throw new Error("CredentialWIthClaims can't be mapped to VerifiableCredentialWithClaims");
    }
}
